export default {"src":"/_next/static/media/tablet-moderate.7d2da302.svg","height":75,"width":80};